import { type WorkerRequirement } from "../api/types";

export function isRequirementInstantReview(workerRequirement?: WorkerRequirement): boolean {
  const {
    isAutomatedVerificationDecision,
    helloSignConfig,
    pandaDocConfig,
    resubmissionDisabledFor,
  } = workerRequirement?.requirement?.attributes ?? {};

  const isResubmissionDisabled =
    workerRequirement?.status &&
    resubmissionDisabledFor?.statuses?.includes(workerRequirement.status);
  return Boolean(
    !isResubmissionDisabled &&
    isAutomatedVerificationDecision &&
    (helloSignConfig?.isEmbeddedFlowEnabled || pandaDocConfig?.templateId)
  );
}
